import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Inject, Injectable, Injector } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
    constructor(
        @Inject(Injector) private readonly injector: Injector
    ) {
        super();
    }

    override handleError(error: any) {

        // Check if it's an error from an HTTP response
        if (!(error instanceof HttpErrorResponse)) {
            // Extract error message properly
            let errorMsg: string;
            if (typeof error === 'string') {
                errorMsg = error;
            } else {
                errorMsg = error?.error || error?.message || error?.statusText || 'UNDEFINED_CLIENT_ERROR';
            }
            error = errorMsg;
        }

        //this.toastrService.error(error);
        super.handleError(error);
    }

    private get toastrService(): ToastrService {
        return this.injector.get(ToastrService);
    }
}